import type { StockItem } from "@app/vue/pages/Inventory/subpages/Stock/types";
import { toBaseQty } from "@app/vue/pages/Inventory/subpages/Stock/units";

export { toBaseQty, unitOptions } from "@app/vue/pages/Inventory/subpages/Stock/units";

// Client-side mirror of packages/db/sql/functions/inventory/recipes_get.sql, so
// the editor can show cost while a recipe is edited.

export type EditableLine = {
  stock_item_id: number | null;
  net_qty: number;
  unit: string;
  loss_pct: number;
};

export type LineCost = { baseQtyPerPortion: number | null; cost: number | null };

/** Base units and cost per portion for one line, at the latest price paid. */
export function lineCost(
  line: EditableLine,
  item: StockItem | undefined,
  yieldPortions: number,
): LineCost {
  if (!item || !line.net_qty || yieldPortions <= 0) {
    return { baseQtyPerPortion: null, cost: null };
  }
  const base = toBaseQty(item, line.net_qty, line.unit);
  if (base == null) return { baseQtyPerPortion: null, cost: null };
  const perPortion = base / (1 - (line.loss_pct || 0) / 100) / yieldPortions;
  const unitCost = item.last_cost ?? item.avg_cost;
  return { baseQtyPerPortion: perPortion, cost: perPortion * unitCost };
}
